<div class="header-bar">
    <i class="{{ headerIcon }} header-icon"></i>
    <div
        class="page-header-item"
        *ngFor="let element of breadcrumbElements; last as isLast">
        <span [ngClass]="isLast ? 'page-header-last-item' : 'page-header-item-customization'">{{ element | translate }}</span
        ><i
            [style.display]="isLast ? 'none' : ''"
            class="ci-right-arrow arrow-margin"></i>
    </div>
</div>
